import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="404 - Page non trouvée | Collectif Ibbü"
        description="La page que vous recherchez n'existe pas ou a été déplacée."
        canonical="https://collectif-ibbu.org"
      />
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center space-y-6 px-4">
          <h1 className="text-6xl md:text-8xl font-bold text-primary">404</h1>
          <p className="text-2xl md:text-3xl font-semibold text-foreground">Page non trouvée</p>
          <p className="text-lg text-muted-foreground max-w-md mx-auto">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          <Button asChild size="lg">
            <Link to="/">
              Retour à l'accueil
            </Link>
          </Button>
        </div>
      </div>
    </>
  );
};

export default NotFound;
